
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/router",
      function () {
        return require("private-next-pages/liquidity/router/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity/router"])
      });
    }
  